/**
 * SGKC008A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { TankatableMeisaiInfo } from "./tankatableMeisaiInfo";
import { TankatableregistrationInfo } from "./tankatableregistrationInfo";

export interface Sgkc008aReqTankatableregistrationInfoDto {

    /**
     * 適用開始年月
     */
    applyStartyearmonth?: string;
    /**
     * 単価表登録基本情報
     */
    tankatableregistrationBasicInfo?: TankatableregistrationInfo;
    /**
     * 単価表登録明細情報
     */
    tankatableregistrationMeisaiInfo?: TankatableMeisaiInfo;
}

